import * as React from "react"
import {isEmpty as _isEmpty} from "lodash"
import { ChangeEvent } from "react" 
import { IPatientHabits } from "@curefit/ehr-common";
import TextInput from "../TextInput";

/**
 * Created by abhinav on 28/01/18.
 */

export interface IHabitItemEditorProps {
    item: IPatientHabits;
    onDataChange: (update: any) => any
}

class HabitItemEditor extends React.Component<IHabitItemEditorProps> {
    constructor(props: IHabitItemEditorProps) {
        super(props)
    }

    onHabitNameChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        let updatedItem = Object.assign({}, this.props.item, {habitCode: event.target.value});
        this.props.onDataChange(updatedItem);
    };

    onHabitSubNameChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        let updatedItem = Object.assign({}, this.props.item, {subHabits: event.target.value});
        this.props.onDataChange(updatedItem);
    };

    render() {
        let habitCode = _isEmpty(this.props.item.habitCode) ? "" : this.props.item.habitCode;
        let subHabits = _isEmpty(this.props.item.subHabits) ? "" : this.props.item.subHabits;
        return (
            <div className="habit-item-editor" >
                <div className="habit-editor-name">
                    <TextInput name="habit-name" value={habitCode} onChange={this.onHabitNameChange}/>
                </div>
                <div className="habit-editor-comment">
                    <TextInput name="habit-comment" value={subHabits} placeholder={"Additional Comments"} onChange={this.onHabitSubNameChange}/>
                </div>
            </div>
        )
    }
}

export default HabitItemEditor;
